/*
src/local/LocalComms.js
wgbh-skydiagram-testing
astro.unl.edu
2019-07-12
*/


import {CallbackMakerMixin} from '../utils/CallbackMakerMixin.js';


/*

Propertes:
	isLaunchAllowed

Methods:
	getIsLaunchAllowed
	launchPreview

Callbacks:
	change		- called when isLaunchAllowed has changed; no data provided

*/


export class LocalComms {


	constructor(workspace) {

		this._delayedInit = this._delayedInit.bind(this);

		this._isInited = false;

		this._workspace = workspace;
		this._workspace.registerCallback('ready', this._delayedInit);

		CallbackMakerMixin.apply(this);
	}


	_delayedInit() {

		this._paramsMan = this._workspace.getParamsManager();
		this._optionsMan = this._workspace.getOptionsManager();

		this._ignoreParamsManagerChangeCallback = false;

		this._launchTimeout = null;
		this._previewWindow = null;

		this._onLaunchTimeout = this._onLaunchTimeout.bind(this);
		this._paramsManagerChangeCallback = this._paramsManagerChangeCallback.bind(this);
		this._optionsManagerChangeCallback = this._optionsManagerChangeCallback.bind(this);
		this._previewReadyCallback = this._previewReadyCallback.bind(this);
		this._previewFitToWindowCallback = this._previewFitToWindowCallback.bind(this);

		this._paramsMan.registerCallback('change', this._paramsManagerChangeCallback);
		this._optionsMan.registerCallback('change', this._optionsManagerChangeCallback);

		if (typeof window.skyDiagramPreviewLocalComms !== 'undefined') {
			console.error('LocalComms should be instantiated only once.');
		} else {
			window.skyDiagramPreviewLocalComms = this;
		}

		this._isInited = true;

		this.makeCallback('change');
	}


	/*
	**	Launching Methods
	*/

	getIsLaunchAllowed() {
		return (this._isInited && this._launchTimeout === null);
	}

	launchPreview() {
		// Launches (opens or re-opens) the preview window.

		if (!this.getIsLaunchAllowed()) {
			return;
		}

		let w = window.open(this._workspace.getBasePath() + '/local-preview/', 'SkyDiagramTestingLocalPreview');
		if (w !== null) {
			this._launchTimeout = window.setTimeout(3000, this._onLaunchTimeout);
			this.makeCallback('change');
		} else {
			console.error('window.open returned null.');
		}
	}

	_onLaunchTimeout() {
		console.error('Preview window launch timed-out.');
		this._launchTimeout = null;
		this.makeCallback('change');
	}


	/*
	**	Params/Options Callbacks	
	*/

	_paramsManagerChangeCallback(type, item, data) {

		if (data.deltaParams === null) {
			console.log('no change to params');
			return;
		}

		if (this._ignoreParamsManagerChangeCallback) {
			return;
		}

		if (this._previewWindow !== null) {

//			console.log('Will update params...');
//			for (const key in data.deltaParams) {
//				console.log(' ' + key + ': ' + data.deltaParams[key]);
//			}

			this._previewWindow.updatePreview(data.deltaParams);
		}
	}

	_optionsManagerChangeCallback(type, caller, options) {

		if (this._previewWindow !== null) {

//			console.log("Will update options...");
//			for (const key in options) {
//				console.log(" " + key + ": "+options[key]);
//			}

			this._previewWindow.updatePreview({}, options);
		}
	}


	/*
	**	Preview Page Callbacks
	*/
	
	_previewReadyCallback(previewWindow) {
		// Called by the preview window when is has finished launching and is ready for updates.
		// It is also called every time the page is re-loaded.

		let needsCallback = false;

		if (this._launchTimeout !== null) {
			window.clearTimeout(this._launchTimeout);
			this._launchTimeout = null;
			needsCallback = true;
		}

		this._previewWindow = previewWindow;

		let fullParams = this._paramsMan.getParams();
		let fullOptions = this._optionsMan.getOptions();
		this._previewWindow.updatePreview(fullParams, fullOptions);

		if (needsCallback) {
			this.makeCallback('change');
		}
	}
	
	_previewFitToWindowCallback(width, height) {
		// Called by the preview window when it has fit the diagram to the window size.

		// Don't redundantly update the preview window when it has resized to fit.
		this._ignoreParamsManagerChangeCallback = true;
		this._paramsMan.setParams({width: width, height: height});
		this._ignoreParamsManagerChangeCallback = false;
	}

}


